import { render, staticRenderFns } from "./Attack.vue?vue&type=template&id=60d9ddee"
import script from "./Attack.vue?vue&type=script&lang=js"
export * from "./Attack.vue?vue&type=script&lang=js"
import style0 from "./Attack.vue?vue&type=style&index=0&id=60d9ddee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports